import { baseOstomySchema } from '../validations/shared/ostomy';
const shape = baseOstomySchema.shape;
export const ostomyStatusFields = [
    { key: 'location', field: shape.location },
    { key: 'status', field: shape.status },
    { key: 'amtDrainage', field: shape.amtDrainage },
];
export const typeFields = [
    { key: 'ostomyType', field: shape.ostomyType },
    { key: 'ostomyAge', field: shape.ostomyAge },
    { key: 'ostomySurgeryDate', field: shape.ostomySurgeryDate, formatDate: true },
];
export const complicationFields = [
    { key: 'recentComplication', field: shape.recentComplication, variant: 'tags' },
    { key: 'hospitalizationDetail', field: shape.hospitalizationDetail },
];
export const stomaFields = [
    { key: 'stomaColor', field: shape.stomaColor },
    { key: 'stomaShape', field: shape.stomaShape },
    { key: 'stomaHeight', field: shape.stomaHeight },
    { key: 'stomaWidthMm', field: shape.stomaWidthMm },
    { key: 'stomaHeightMm', field: shape.stomaHeightMm },
    { key: 'stomaSizeChange', field: shape.stomaSizeChange },
    { key: 'stomaFunction', field: shape.stomaFunction },
];
export const mucosaFields = [
    { key: 'stomaMucosa', field: shape.stomaMucosa, variant: 'tags' },
];
export const skinFields = [
    { key: 'skinZone1', field: shape.skinZone1 },
    { key: 'skinZone2', field: shape.skinZone2 },
    { key: 'skinZone3', field: shape.skinZone3 },
    { key: 'leakageHistory', field: shape.leakageHistory },
];
export const leakageCauseFields = [
    { key: 'leakageCause', field: shape.leakageCause, variant: 'tags' },
];
export const applianceFields = [
    { key: 'applianceSystem', field: shape.applianceSystem },
    { key: 'waferType', field: shape.waferType },
    { key: 'applianceBrand', field: shape.applianceBrand },
    { key: 'pouchChangeThisVisit', field: shape.pouchChangeThisVisit },
    { key: 'daysSinceWaferChange', field: shape.daysSinceWaferChange },
    { key: 'waferOpeningMm', field: shape.waferOpeningMm },
];
export const accessoriesFields = [
    { key: 'accessories', field: shape.accessories, variant: 'tags' },
];
export const outputFields = [
    { key: 'outputConsistency', field: shape.outputConsistency },
    { key: 'outputColor', field: shape.outputColor },
    { key: 'outputVolume', field: shape.outputVolume },
    { key: 'outputOdor', field: shape.outputOdor },
];
export const whoManagesFields = [
    { key: 'whoManages', field: shape.whoManages, variant: 'tags' },
];
export const skillFields = [{ key: 'skillLevel', field: shape.skillLevel }];
export const techniqueFields = [
    { key: 'techniqueObserved', field: shape.techniqueObserved, variant: 'tags' },
];
export const educationTopicsFields = [
    { key: 'educationTopics', field: shape.educationTopics, variant: 'tags' },
];
export const learnerFields = [
    { key: 'educationLearner', field: shape.educationLearner, variant: 'tags' },
];
export const ostomyComprehensionFields = [
    { key: 'educationComprehension', field: shape.educationComprehension },
    { key: 'supplyAdequacy', field: shape.supplyAdequacy },
];
export const dialysisFields = [
    { key: 'dialysis', field: shape.dialysis, variant: 'tags' },
];
export const ostomyNarrativeFields = [
    { key: 'ostomyChange', field: shape.ostomyChange },
    { key: 'mdNotifTime', field: shape.mdNotifTime },
    { key: 'mdOrders', field: shape.mdOrders },
    { key: 'ostomyNarrative', field: shape.ostomyNarrative },
];
